<template>
  <BaseCardV2
    :has-btn-action="false"
    class="pa-2"
    has-help
    titre="Répartition des surfaces"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading.repartitionAdherent" />
      <BaseMessageServerError
        v-if="erreur.repartitionAdherent || erreur.repartitionGroupe"
        class="mx-5 my-2"
      />
      <v-row
        v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
        class="mt-2 ml-2"
        no-gutters
      >
        <v-col
          cols="12"
          md="6"
        >
          <v-icon
            class="mr-1 positif-color"
            size="14"
          >
            mdi-circle
          </v-icon>
          <span class="texte texte-gris-fonce">
            Mon atelier cultures de vente
          </span>
        </v-col>
        <v-col
          cols="12"
          md="5"
        >
          <v-icon
            size="14"
            color="grey lighten-2"
            class="mr-1"
          >
            mdi-circle
          </v-icon>
          <span class="texte texte-gris-fonce">
            Autres ateliers
          </span>
        </v-col>
      </v-row>
      <div
        v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'position-percent-mobile' : 'position-percent'"
      >
        <div
          class="chiffre-xxl align-self-center positif-color"
        >
          {{ repartitionSurface.ratioGrandesCulturesEnHectare | roundNumber(0) }}
        </div>
        <div
          class="titre-h1 align-self-center ml-1 positif-color"
        >
          %
        </div>  
      </div>
      <v-row
        v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
        no-gutters
        justify="center"
        class="mt-6"
      >
        <v-col
          cols="12"
          class="mt-3"
          align="center"
        >
          <PercentageDoughnut
            :data="{
              percentage: repartitionSurface.ratioGrandesCulturesEnHectare >= 100 ? 99.99 : repartitionSurface.ratioGrandesCulturesEnHectare,
              value: repartitionSurface.surfaceGrandesCulturesEnHectare,
              unit: 'ha',
              label: 'Surface de cultures de vente',
              others: {
                value: repartitionSurface.surfaceAutresCulturesEnHectare,
                label: 'Autres surfaces'
              }
            }"
            :size="$vuetify.breakpoint.mobile ? 160 : 200"
            width="30"
            positive-color="#dbbd00"
            negative-color="#ec6608"
          >
            <img
              alt="picto-ferme"
              class="picto-ferme"
              src="@/assets/picto-ferme.svg"
            >
          </PercentageDoughnut>
        </v-col>
      </v-row>
      <div class="bottom">
        <v-divider
          v-if="!loading.repartitionAdherent"
          class="my-6 mx-3"
        />
        <div class="d-flex justify-space-between mx-3">
          <div
            class="d-flex flex-column"
          >
            <div
              v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
              class="titre-h4 texte-gris-fonce mb-2"
            >
              Total SAU
            </div>
            <div
              v-if="!loading.repartitionAdherent && !erreur.repartitionAdherent"
              class="d-flex"
            >
              <span class="titre-h3 secondary--text align-self-center mr-2">{{ repartitionSurface.surfaceTotaleEnHectare | roundNumber(0) | splitNumber }} ha</span>
              <BaseEvolutionWithInfo
                v-if="repartitionSurface.evolutionSurfaceTotaleEnPourcentage != null"
                :evolution-value="repartitionSurface.evolutionSurfaceTotaleEnPourcentage"
                :values="repartitionSurface.surfaceTotaleParAnnee"
                :unite="'ha'"
              />
            </div>
          </div>
          <div class="ml-auto">
            <UserIndicatorJauge
              v-if="!loading.repartitionAdherent && !erreur.repartitionGroupe"
              :chargement="loading.repartitionGroupe"
              :data="{
                value: positionJaugeGroupe(repartitionSurfaceGroupe?.codePositionDuNumtiers)
              }"
              :unite="'ha'"
              :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
              :data-groupe="repartitionSurfaceGroupe?.valeurMoyenneDuGroupe"
              :negative-color="repartitionSurfaceGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
              :positive-color="repartitionSurfaceGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
            />
          </div>
        </div>
      </div>
      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition des surfaces"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-8">
            <p>Retrouvez la surface de vos cultures affectées à votre atelier cultures de vente.</p>
            <p class="pt-2">
              Comparez la Surface Agricole Utile (SAU) aux années précédentes et à un groupe de comparaison (au niveau du compteur).
            </p>
            <p class="pt-2">
              Le quart supérieur du groupe est matérialisé en vert, le quart inférieur est lui, en orange. Quant aux valeurs intermédiaires (entre 25 et 75% des valeurs du groupe), elle sont affichées en grises.
            </p>
          </div>
        </div>
      </HelpModal>
    </div>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import { mapActions, mapGetters } from 'vuex' 
import BaseLoader from '@/components/common/base-loader.vue'
import PercentageDoughnut from '@/components/chart/v2/percentage-doughnut.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import { isPanneServeur } from '@/utils/requete'

export default {
  name: 'RepartitionSurfaces',
  components: {BaseEvolutionWithInfo, BaseLoader, BaseMessageServerError, BaseCardV2, PercentageDoughnut, HelpModal, UserIndicatorJauge },
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      loading: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      erreur: {
        repartitionAdherent: false,
        repartitionGroupe: false
      }
    }
  },

  computed: {
    ...mapGetters({
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      repartitionSurface: 'culture/repartitionSurface',
      repartitionSurfaceGroupe: 'culture/repartitionSurfaceGroupe',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
    })
  },
  watch: {
    anneeRecolteSelected: {
      handler () {
        this.loadRepartitionAdherent()
        this.loadRepartitionGroupe()
      },
      immediate: true
    },
    codeGraineRs3Selected () {
      this.loadRepartitionAdherent()
      this.loadRepartitionGroupe()
    },
    filtresAdherent () {
      this.loadRepartitionGroupe()
    }
  },
  methods: {
    ...mapActions({
      getRepartitionDesSurfaces: 'culture/getRepartitionDesSurfaces',
      getRepartitionDesSurfacesGroupe: 'culture/getRepartitionDesSurfacesGroupe'
    }),
    loadRepartitionAdherent () {
      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getRepartitionDesSurfaces()
        .catch(erreur => this.erreur.repartitionAdherent = isPanneServeur(erreur))
        .finally(() => this.loading.repartitionAdherent = false)
    },
    loadRepartitionGroupe () {
      this.loading.repartitionGroupe = true
      this.erreur.repartitionGroupe = false
      this.getRepartitionDesSurfacesGroupe()
        .catch(erreur => this.erreur.repartitionGroupe = isPanneServeur(erreur))
        .finally(() => this.loading.repartitionGroupe = false)
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    }
  }
}

</script>

<style lang="scss" scoped>
.picto-ferme {
  width: 32%;
}
.positif-color {
  color: #dbbd00;
}
.position-percent-mobile {
  position: absolute;
  right: 8px;
  top: 110px;
}
.position-percent {
  position: absolute;
  right: 45px;
  top: 110px;
}
</style>
